import { Box, Typography } from '@mui/material';
import typography from '../../styles/typography.module.css';
import layout from '../../styles/layout.module.css';
import { useTranslation } from 'react-i18next';
export const Impedance = ({ model, impedance }) => {
    const { t } = useTranslation();
    const impendanceInfo = t(`${model}.impedance`);
    const info =
        impendanceInfo.localeCompare(`${model}.impedance`) === 0 || impendanceInfo === undefined
            ? impedance
            : impendanceInfo;
    return (
        <Box className={layout.subSectionContainer}>
            <Typography>
                <span className={typography.modelDescriptionSubTitle}>
                    {t('model.impedance')}:{' '}
                </span>
                <span className={typography.modelDescription}> {info} </span>
            </Typography>
        </Box>
    );
};
